/**
 * BRUME - Buy Page JavaScript Entry Point (Shopify)
 * Product detail page with color variant switching and slideshow
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // Force header into scrolled state (no hero on this page)
    var header = document.getElementById('header');
    if (header) {
      header.classList.add('is-scrolled');
    }

    // Initialize header scroll behavior (for hide/show on scroll)
    if (typeof Brume !== 'undefined' && Brume.initHeader) {
      Brume.initHeader();
    }

    // Initialize slideshow with color-aware filtering
    if (typeof Brume !== 'undefined' && Brume.initBuyPageSlideshow) {
      Brume.initBuyPageSlideshow();
    }

    // Initialize color selector
    if (typeof Brume !== 'undefined' && Brume.initColorSelector) {
      Brume.initColorSelector();
    }

    // Initialize cart system
    if (typeof Brume !== 'undefined' && Brume.initCartDrawer) {
      Brume.initCartDrawer();
    }
    if (typeof Brume !== 'undefined' && Brume.initCartIcon) {
      Brume.initCartIcon();
    }

    // Initialize FAQ accordion
    if (typeof Brume !== 'undefined' && Brume.initFaq) {
      Brume.initFaq();
    }

    // One-time / Subscribe selector: highlight the chosen plan card
    var planInputs = document.querySelectorAll('input[name="purchase-plan"]');

    // Sync the selected plan's price into every Add to Bag button (main + sticky
    // bar), e.g. "Add To Bag - $79". Skips buttons mid-feedback (disabled) and
    // any without a price (e.g. refill stays plain "Add to Bag").
    function selectedPrice() {
      var checked = document.querySelector('input[name="purchase-plan"]:checked');
      return checked ? (checked.getAttribute('data-price') || '') : '';
    }
    // The cart line matching what's currently selected here (same variant, and
    // same one-time/subscription choice), or null if it isn't in the bag yet.
    function cartLineForSelection() {
      if (!window.Brume || !Brume.Cart || !Brume.Cart.getCart) return null;
      var variantInput = document.getElementById('variantId');
      if (!variantInput) return null;
      var vid = parseInt(variantInput.value, 10);
      var checked = document.querySelector('input[name="purchase-plan"]:checked');
      var wantsPlan = !!(checked && checked.getAttribute('data-selling-plan'));
      var cart = Brume.Cart.getCart();
      for (var i = 0; i < cart.length; i++) {
        var line = cart[i];
        var lineVid = line.variant_id || line.id;
        var hasPlan = !!(line.selling_plan_allocation || line.selling_plan);
        if (lineVid === vid && hasPlan === wantsPlan) return line;
      }
      return null;
    }

    // A line capped at one unit is already fully in the bag. Adding again would
    // silently do nothing, so the button says "Added" rather than inviting a
    // click that has no effect.
    function selectionIsMaxed() {
      var line = cartLineForSelection();
      if (!line) return false;
      var cap = (window.Brume && Brume.maxQtyFor) ? Brume.maxQtyFor(line) : 99;
      return cap === 1 && line.quantity >= cap;
    }

    function updateBuyLabels() {
      var maxed = selectionIsMaxed();
      var price = selectedPrice();
      document.querySelectorAll('.btn-add-cart').forEach(function(btn) {
        if (maxed) {
          btn.textContent = 'Added';
          btn.disabled = true;
          btn.classList.add('is-added');
          return;
        }
        // Only re-enable buttons this logic disabled — never one that's mid
        // add-to-cart feedback.
        if (btn.classList.contains('is-added')) {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }
        if (btn.disabled) return;
        var base = btn.getAttribute('data-label') || btn.textContent.trim();
        btn.textContent = price ? base + ' - ' + price : base;
      });
    }

    planInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        document.querySelectorAll('.plan-option').forEach(function(opt) {
          opt.classList.toggle('is-selected', opt.contains(input) && input.checked);
        });
        updateBuyLabels();
      });
    });
    updateBuyLabels();
    initBundlePicker();
    // Re-check whenever the bag changes, so removing the item from the drawer
    // turns the button back into "Add To Bag" without a reload.
    if (window.Brume && Brume.Cart && Brume.Cart.onCartChange) {
      Brume.Cart.onCartChange(updateBuyLabels);
    }

    // Quantity stepper
    var qtyValueEl = document.getElementById('qtyValue');
    var qtyStepper = document.querySelector('.qty-stepper');
    function getQty() {
      var q = qtyValueEl ? parseInt(qtyValueEl.textContent, 10) : 1;
      return (isNaN(q) || q < 1) ? 1 : q;
    }
    // A page can cap the quantity for subscriptions via data-max-qty-subscribe.
    // The refill page sets it to 1: a recurring cartridge has no sensible
    // quantity above 1, and a free first order removes the price friction that
    // would otherwise stop someone adding many.
    function maxQty() {
      var checked = document.querySelector('input[name="purchase-plan"]:checked');
      var isSub = checked && checked.value === 'subscribe';
      if (isSub && qtyStepper && qtyStepper.getAttribute('data-max-qty-subscribe')) {
        var cap = parseInt(qtyStepper.getAttribute('data-max-qty-subscribe'), 10);
        if (!isNaN(cap) && cap > 0) return cap;
      }
      return 99;
    }
    // Hide the "+" once the cap is reached so the limit is visible, not just enforced.
    function syncQtyUI() {
      var max = maxQty();
      var plus = qtyStepper ? qtyStepper.querySelector('.qty-btn[data-qty="1"]') : null;
      if (plus) plus.disabled = getQty() >= max;
      if (qtyStepper) qtyStepper.classList.toggle('is-capped', max === 1);
    }
    document.querySelectorAll('.qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (!qtyValueEl) return;
        var delta = parseInt(btn.getAttribute('data-qty'), 10) || 0;
        var next = getQty() + delta;
        if (next < 1) next = 1;
        if (next > maxQty()) next = maxQty();
        qtyValueEl.textContent = next;
        syncQtyUI();
      });
    });
    // Switching to a capped plan must clamp a quantity chosen under the old plan.
    planInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        if (qtyValueEl && getQty() > maxQty()) qtyValueEl.textContent = maxQty();
        syncQtyUI();
      });
    });
    syncQtyUI();

    // Subscription terms modal
    var subModal = document.getElementById('subTermsModal');
    if (subModal) {
      function closeSubModal() {
        subModal.classList.remove('is-open');
        subModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
      document.querySelectorAll('[data-sub-terms-open]').forEach(function(opener) {
        opener.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          subModal.classList.add('is-open');
          subModal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });
      });
      subModal.querySelectorAll('[data-sub-terms-close]').forEach(function(closer) {
        closer.addEventListener('click', closeSubModal);
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && subModal.classList.contains('is-open')) closeSubModal();
      });
    }

    /* Bundle colour picker: two rows of swatches, one per device. The chosen
       variant ids live on the bundle radio's data-bundle-variants, which is
       what addCurrentToCart reads, so picking a colour needs no other wiring. */
    function initBundlePicker() {
      var swatches = document.querySelectorAll('[data-bundle-slot]');
      if (!swatches.length) return;
      var radio = document.querySelector('input[name="purchase-plan"][data-bundle-variants]');
      if (!radio) return;

      function choose(slot, id, title) {
        var ids = radio.getAttribute('data-bundle-variants').split(',');
        var titles = (radio.getAttribute('data-bundle-titles') || '').split(',');
        ids[slot] = String(id);
        titles[slot] = title;
        radio.setAttribute('data-bundle-variants', ids.join(','));
        radio.setAttribute('data-bundle-titles', titles.join(','));

        var valueEl = document.querySelector('[data-bundle-value="' + slot + '"]');
        if (valueEl) valueEl.textContent = title;
        var nameEl = document.querySelector('[data-bundle-name="' + slot + '"]');
        if (nameEl) nameEl.textContent = title;
      }

      /* Both slots mirror the main colour selector until the customer picks a
         colour inside the bundle themselves: choosing Pearl White above should
         offer two Pearl White devices, not one of each. Once they have touched
         a bundle swatch, their pair stands and the main selector leaves it be. */
      var picked = false;

      function setSlot(slot, id, title) {
        document.querySelectorAll('[data-bundle-slot="' + slot + '"]').forEach(function (el) {
          el.classList.toggle('is-active', el.getAttribute('data-variant-id') === String(id));
        });
        choose(slot, id, title);
      }

      function followMainColour(swatch) {
        if (picked || !swatch) return;
        var id = swatch.getAttribute('data-variant-id');
        if (!id) return;
        var title = swatch.getAttribute('title') || '';
        setSlot(0, id, title);
        setSlot(1, id, title);
      }

      document.querySelectorAll('.color-selector .color-swatch').forEach(function (sw) {
        sw.addEventListener('click', function () { followMainColour(sw); });
      });
      /* initColorSelector runs first and has already applied any ?variant=
         deep link, so the active swatch is the real starting colour. */
      followMainColour(document.querySelector('.color-selector .color-swatch.active'));

      swatches.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          /* The swatches sit inside the plan's <label>, so a plain click would
             also re-toggle the radio. Handle the selection here instead. */
          e.preventDefault();
          e.stopPropagation();
          if (!radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          picked = true;
          var slot = btn.getAttribute('data-bundle-slot');
          document.querySelectorAll('[data-bundle-slot="' + slot + '"]').forEach(function (el) {
            el.classList.toggle('is-active', el === btn);
          });
          choose(slot, btn.getAttribute('data-variant-id'), btn.getAttribute('data-variant-title') || '');
        });
      });
    }

    // Wire up every Add to Cart button (main + sticky bar) to one handler.
    function setAllBtns(text) {
      document.querySelectorAll('.btn-add-cart').forEach(function(b) { b.textContent = text; });
    }
    function addCurrentToCart() {
      var variantInput = document.getElementById('variantId');
      if (!variantInput) return;

      var variantId = parseInt(variantInput.value);
      var qty = getQty();

      // If "Subscribe" is chosen, attach the filter's tiered selling plan.
      var checkedPlan = document.querySelector('input[name="purchase-plan"]:checked');
      var sellingPlan = null;
      if (checkedPlan) {
        var sp = checkedPlan.getAttribute('data-selling-plan');
        if (sp) sellingPlan = parseInt(sp);
      }

      /* The two-colour bundle adds one of each variant in a single request.
         Its 20% comes from a Shopify discount on the cart, so each line is
         drawn at full price and Shopify's reply shows the discounted figure. */
      var bundleEl = document.querySelector('input[name="purchase-plan"]:checked[data-bundle-variants]');
      if (bundleEl) {
        var ids = bundleEl.getAttribute('data-bundle-variants').split(',');
        var titles = (bundleEl.getAttribute('data-bundle-titles') || '').split(',');
        var unit = parseInt(bundleEl.getAttribute('data-unit-cents'), 10) || 0;
        /* Tag the pair with its own colour combination rather than a bare
           'duo', so two different bundles stay two rows in the drawer instead
           of folding into one mislabelled row. Sorted, so Silver + White and
           White + Silver are the same bundle. */
        var bundleKey = 'duo:' + ids.map(function (x) { return String(x).trim(); }).sort().join('-');
        var bundleItems = [], bundlePreviews = [], seen = {};
        for (var b = 0; b < ids.length; b++) {
          var vid = parseInt(ids[b], 10);
          /* Both devices the same colour is one cart line of double quantity:
             Shopify merges identical lines anyway, and sending two would leave
             the drawer showing a pair that is really one line. */
          if (seen[vid] !== undefined) {
            bundleItems[seen[vid]].quantity += qty;
            bundlePreviews[seen[vid]].variant_title = titles[b] || '';
            continue;
          }
          seen[vid] = bundleItems.length;
          /* _bundle (underscore: hidden at checkout) tells the drawer these
             lines belong together, so it can show the pair as one row, and it
             keeps them apart from a single filter of the same colour. */
          bundleItems.push({ id: vid, quantity: qty, properties: { _bundle: bundleKey } });
          bundlePreviews.push({
            title: (window.BrumeConfig && BrumeConfig.productTitle) || '',
            variant_title: titles[b] || '',
            price: unit,
            handle: 'brume-filter',
            properties: { _bundle: bundleKey }
          });
        }
        var bundleBtns = document.querySelectorAll('.btn-add-cart');
        bundleBtns.forEach(function(x) { x.disabled = true; });
        Brume.openDrawer();
        if (Brume.setCartLoading) Brume.setCartLoading(true);
        Brume.Cart.addItems(bundleItems, bundlePreviews).then(function() {
          if (Brume.setCartLoading) Brume.setCartLoading(false);
          setAllBtns('Added!');
        }).catch(function(err) {
          var soldOut = /sold out/i.test(err && err.message);
          if (Brume.showCartError) {
            Brume.showCartError(soldOut ? 'Sorry, one of these colors is sold out.' : 'Could not add to bag. Please try again.');
          }
          setAllBtns(soldOut ? 'Sold Out' : 'Unavailable');
          console.error('Brume Cart: Failed to add bundle', err);
        }).then(function() {
          setTimeout(function() {
            document.querySelectorAll('.btn-add-cart').forEach(function(x) { x.disabled = false; });
            updateBuyLabels();
          }, 1800);
        });
        return;
      }

      var btns = document.querySelectorAll('.btn-add-cart');
      // Prevent double-clicks while the request is in flight.
      btns.forEach(function(b) { b.disabled = true; });

      // Open the drawer immediately with a loading state so it feels instant.
      Brume.openDrawer();
      if (Brume.setCartLoading) Brume.setCartLoading(true);

      /* What the drawer needs to draw the line before Shopify replies. The
         image and the cartridge/filter distinction are worked out in the
         drawer from the variant title and handle, as for a real line. */
      var planEl = document.querySelector('input[name="purchase-plan"]:checked');
      var swatch = document.querySelector('.color-swatch.active');
      /* The refill page names its own product (the cartridge, one variant);
         without that the line was first drawn as the filter. */
      var pageProduct = window.BrumeProduct || {};
      var preview = {
        title: pageProduct.title || (window.BrumeConfig && BrumeConfig.productTitle) || '',
        variant_title: pageProduct.handle ? '' : (swatch ? (swatch.getAttribute('title') || '') : ''),
        price: planEl ? parseInt(planEl.getAttribute('data-price-cents'), 10) || 0 : 0,
        handle: pageProduct.handle || 'brume-filter'
      };

      Brume.Cart.addToCart(variantId, qty, sellingPlan, preview).then(function() {
        if (Brume.setCartLoading) Brume.setCartLoading(false);
        setAllBtns('Added!');
      }).catch(function(err) {
        var soldOut = /sold out/i.test(err && err.message);
        if (Brume.showCartError) {
          Brume.showCartError(soldOut ? 'Sorry, this color is sold out.' : 'Could not add to bag. Please try again.');
        }
        setAllBtns(soldOut ? 'Sold Out' : 'Unavailable');
        console.error('Brume Cart: Failed to add item', err);
      }).then(function() {
        setTimeout(function() {
          document.querySelectorAll('.btn-add-cart').forEach(function(b) { b.disabled = false; });
          updateBuyLabels();
        }, 1800);
      });
    }
    document.querySelectorAll('.btn-add-cart').forEach(function(btn) {
      btn.addEventListener('click', addCurrentToCart);
    });

    /* The bag icon on the ALREADY-SELECTED plan doubles as an add-to-cart
       button. On an unselected plan it does nothing special — the surrounding
       <label> just selects that plan, so it still takes two taps to buy: one to
       choose, one to add. Only the icon is wired up, not the whole card, so
       tapping the card to re-read the price can't add an item by accident. */
    document.querySelectorAll('.plan-bag').forEach(function(bag) {
      bag.addEventListener('click', function(e) {
        var opt = bag.closest('.plan-option');
        if (!opt) return;
        var input = opt.querySelector('input[name="purchase-plan"]');
        if (!input || !input.checked) return; // not selected yet: let the label do its job
        // Stop the label from re-activating the radio and firing a needless change.
        e.preventDefault();
        e.stopPropagation();
        addCurrentToCart();
      });
    });

    // Sticky Add to Bag bar: reveal once the main button scrolls above the viewport.
    var mainBuyBtn = document.querySelector('.buy-page-info .btn-add-cart');
    var stickyBar = document.getElementById('buyStickyBar');
    if (mainBuyBtn && stickyBar && 'IntersectionObserver' in window) {
      var stickyObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', scrolledPast);
          stickyBar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
          // Lift the help widget so the bar doesn't cover it.
          document.body.classList.toggle('buy-sticky-open', scrolledPast);
        });
      }, { threshold: 0 });
      stickyObs.observe(mainBuyBtn);
    }
  });

})();
